module.exports = __webpack_public_path__ + "img/logo.87581250.png";